// BonBoZ: bóc chú thích của cầu nối Zalo ra khỏi thân tin.
//
// Cầu nối nhét hai mẩu chú thích thẳng vào nội dung tin:
//
//   `**Tên:**\n…`       ai vừa nói trong nhóm. Cầu nối nay gửi tên người nói
//                       thành `content_attributes.bonboz_sender_name`, nhưng
//                       mọi tin đã lưu trước đó vẫn giữ dạng cũ này.
//   `📱 từ app Zalo\n…` tin do chính nhân viên gửi từ app Zalo trên điện thoại,
//                       cầu nối vẫn đang gắn.
//
// Cả hai đều là chú thích chứ không phải lời người ta nói. Nằm trong bong bóng
// thì bong bóng Zalo lệch hẳn so với bong bóng Facebook — mà Facebook là bản
// gốc — và ảnh gửi từ app Zalo bị rơi xuống dạng thẻ đính kèm trong bong bóng
// chữ thay vì hiện thành ảnh. Bóc ra đây để Message.vue vẽ chúng ở ngoài.

// Chỉ hộp thư kênh API mới đi qua cầu nối Zalo. Giới hạn ở đó để một tin
// Facebook mở đầu bằng `**Lưu ý:**` không bị ăn mất dòng đầu.
const ZALO_CHANNEL_TYPE = 'Channel::Api';

// Tên người Zalo không xuống dòng và không dài; chặn độ dài để một đoạn in đậm
// bình thường của khách không bị đọc nhầm thành tên người nói.
const SPEAKER_RE = /^\*\*([^*\n]{1,64}?):\*\*[ \t]*\r?\n?/;
const SELF_RE = /^📱 từ app Zalo[ \t]*(\r?\n|$)/;

const KHONG_CO = { speaker: '', fromZaloApp: false, body: '' };

/**
 * @param {string|null} content Nội dung thô của tin.
 * @param {string} channelType `channel_type` của hộp thư chứa tin.
 * @returns {{ speaker: string, fromZaloApp: boolean, body: string }}
 *   `speaker` tên người nói đọc được từ tin cũ (tin mới trả về rỗng, tên nằm ở
 *   `content_attributes`), `fromZaloApp` tin gửi từ app Zalo, `body` thân tin
 *   đã sạch chú thích.
 */
export function parseZaloMeta(content, channelType) {
  const body = content ?? '';
  if (channelType !== ZALO_CHANNEL_TYPE) return { ...KHONG_CO, body };

  if (SELF_RE.test(body)) {
    return { ...KHONG_CO, fromZaloApp: true, body: body.replace(SELF_RE, '') };
  }

  // Tin của mình không kèm tên người nói, nên hai nhánh này loại trừ nhau.
  const speaker = body.match(SPEAKER_RE);
  if (speaker) {
    return {
      ...KHONG_CO,
      speaker: speaker[1].trim(),
      body: body.slice(speaker[0].length),
    };
  }

  return { ...KHONG_CO, body };
}
